import { OrganizationEngagement } from '../../../../../shared/api/controllers/engagementAnalyticsReporting';

export interface UpsellLocationRate {
    applicationId: string;
    location: string;
    successes: number;
    attempts: number;
    rate: number | null;
}

// Inputs already respect the dashboard's location, date, and language selection.
export const buildUpsellLocationRates = (
    successesByApp: ReadonlyMap<string, number>,
    engagements: readonly Pick<OrganizationEngagement, 'applicationId' | 'sessionTags'>[],
    appNameMap: Record<string, string> = {}
): UpsellLocationRate[] => {
    const attemptsByApp = new Map<string, number>();
    engagements.forEach(engagement => {
        const attempts = (engagement.sessionTags || []).filter(tag => tag.toUpperCase() === 'UPSELL_ATTEMPTED').length;
        attemptsByApp.set(engagement.applicationId, (attemptsByApp.get(engagement.applicationId) || 0) + attempts);
    });
    return Array.from(successesByApp, ([applicationId, successes]) => {
        const attempts = attemptsByApp.get(applicationId) || 0;
        return {
            applicationId,
            location: appNameMap[applicationId] || applicationId,
            successes,
            attempts,
            rate: attempts > 0 ? successes / attempts * 100 : null
        };
    }).sort((a, b) => (b.rate ?? -1) - (a.rate ?? -1) || a.location.localeCompare(b.location));
};
